"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className", "children"];

var ContentCurationList = function ContentCurationList(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _preact.h)("ul", (0, _extends2.default)({
    className: (0, _classnames.default)('topic-curation__list', 'list', className)
  }, rest), children);
};

var _default = ContentCurationList;
exports.default = _default;